export const AdminOpsController = {
    index(): void {},
    run(): void {},
    migrationsIndex(): void {},
    gitIndex(): void {},
    logsIndex(): void {},
    backupsList(): void {},
    backupsDownload(): void {},
    backupsDelete(): void {},
    backupsRestore(): void {},
};
